import { IPublicClientApplication } from "@azure/msal-browser";
import Axios, { AxiosRequestConfig } from "axios";
import { BASE_URL, IS_PRODUCTION } from "../App";

export async function getAuth(
  instance: IPublicClientApplication,
  accounts: any
): Promise<any | void> {
  let tokenAttempt;

  if (IS_PRODUCTION) {
    await instance.handleRedirectPromise().then(async (_) => {
      const request = {
        scopes: ["User.Read"],
        account: accounts[0],
      };

      let idToken: any;

      await instance
        .acquireTokenSilent(request)
        .then((response: any) => {
          idToken = response.idToken;
        })
        .catch(async (e: any) => {
          await instance.acquireTokenRedirect(request).then((response: any) => {
            idToken = response.idToken;
          });
        });

      tokenAttempt = idToken;
    });
  }

  if (!tokenAttempt && !process.env.REACT_APP_LOCAL_TOKEN) {
    console.error("Invalid user.");
    return;
  }

  const config: AxiosRequestConfig = {
    method: "POST",
    url: `${BASE_URL}/api/login?lang=EN`,
    data: {
      MSAuth: {
        id_token: tokenAttempt || process.env.REACT_APP_LOCAL_TOKEN,
      },
    },
  };

  return await Axios(config)
    .then((v) => {
      if (!v.data || !v.data.userAccess) {
        console.error("Failed to login.");
        return;
      }

      let salesOrgs: string[] = [];
      Object.keys(v.data.userAccess.authUser).forEach((cID) => {
        salesOrgs.concat(Object.keys(v.data.userAccess.authUser[cID]));
      });

      return {
        dbSystemInd: (v.data.DB_SYSTEM_IND) || '?',
        token: "Bearer " + v.data.userAccess.token,
        salesOrgs: Object.keys(v.data.userAccess.authUser["100"]),
        userAccess: v.data.userAccess.authUser,
      };
    })
    .catch((err) => console.error(err));
}

export async function getMicrosoftAuth(
  instance: IPublicClientApplication,
  accounts: any
): Promise<any | void> {
  if (IS_PRODUCTION) {
    const request = {
      scopes: ["User.Read"],
      account: accounts[0],
    };
  
    let idToken: any;
  
    await instance
      .acquireTokenSilent(request)
      .then((response: any) => {
        idToken = response.idToken;
      })
      .catch(async (e: any) => {
        await instance.acquireTokenRedirect(request).then((response: any) => {
          idToken = response.idToken;
        });
      });
  
    return idToken;
  }

  return process.env.REACT_APP_LOCAL_TOKEN;
}

export function checkForRole(
  clientId: string,
  salesOrg: string,
  role: string
): boolean {
  let userAccess = window.localStorage.getItem("SETTINGS.userAccess") || "{}";

  let uAcc = JSON.parse(userAccess);
  if (uAcc && uAcc[clientId] && uAcc[clientId][salesOrg]) {
    let curAcc = uAcc[clientId][salesOrg].find((a: string) => a === role);
    if (curAcc) {
      return true;
    }
  }
  return false;
}

export function checkForRoles(
  clientId: string,
  salesOrg: string,
  roles: string[]
): boolean {
  let userAccess = window.localStorage.getItem("SETTINGS.userAccess") || "{}";
  let uAcc = JSON.parse(userAccess);
  let hasAccess: boolean = false;
  if (uAcc && uAcc[clientId] && uAcc[clientId][salesOrg]) {
    roles.forEach((role) => {
      let curAcc = uAcc[clientId][salesOrg].find((a: string) => a === role);
      if (curAcc) {
        hasAccess = true;
      }
    });
  }
  return hasAccess;
}
